module.exports = __webpack_public_path__ + "static/media/bears_free_bagel.c0fe806b.jpg";